export const calcPercentage = (used: number, total: number, capTo100: boolean = true) => {
    const percentage = Math.round((used / total) * 100);
    if (capTo100) {
        return Math.min(100, percentage);
    }
    return percentage
  };